import { Observable } from 'rxjs';

import { CleanPattern } from 'app/model/cris/clean-patterns';

import { RestfulApiService } from './restful-api.service';

class CleanPatternsService extends RestfulApiService<CleanPattern> {
    public deploy(): Observable<void> {
        return this.http.post(`${this.getUrl()}/deploy`);
    }

    protected getFormName(): string {
        return 'clean_patterns';
    }

    protected getPath(): string {
        return 'clean-patterns';
    }
}

export const cleanPatternsService = new CleanPatternsService();
